module.exports = __webpack_public_path__ + "front/img/edm-agenda.7f526b99.png";